import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Table = (props) => {
    const theme = useSelector(() => THEME);
    return (React.createElement("div", { style: {
            overflowX: props.overflowX ? props.overflowX : 'scroll',
            overflowY: 'initial',
            ...props.wrapperStyle,
        } },
        React.createElement(TableStyled, { ...props, theme: theme },
            props.columns && props.columns.length > 0 && (React.createElement("thead", null,
                React.createElement("tr", null, props.columns.map((c, index) => (React.createElement("th", { key: index }, c.title)))))),
            React.createElement("tbody", null, props.children))));
};
export default Table;
const TableStyled = styled.table `
  width: 100%;
  border-collapse: collapse;

  th {
    position: sticky;
    top: 0px;
    background-color: ${(props) => props.theme.COLOR_SECONDARY};
    border-bottom: 3px solid ${(props) => props.theme.COLOR_ACCENT};
    text-align: left;
  }

  & tbody > tr > th,
  & tbody > tr > td {
    padding: 4px 10px;
  }

  & tbody > tr > th.sub-row,
  & tbody > tr > td.sub-row {
    padding: 4px 10px;
  }

  tr:last-child {
    ${(props) => (props.sumRow ? `font-weight: bold` : '')};
  }

  tr:nth-child(odd) {
    ${(props) => (props.zebra ? `background-color: ${THEME.SURFACE_INSET};` : '')};
  }

  .tar {
    text-align: right;
  }

  .tac {
    text-align: center;
  }

  .sub-row {
    font-size: 0.8em;
    opacity: 0.7;
  }
`;
//# sourceMappingURL=Table.js.map